export const STORAGE_KEYS = {
  SITE_CONFIG: 'hs2a-site-config',
  AI_CONFIG: 'hs2a-ai-config',
  AI_PROVIDER_CONFIGS: 'hs2a-ai-provider-configs',
  AI_ANALYSIS_RESULT: 'hs2a-ai-result',
  AI_ANALYSIS_REASONING: 'hs2a-ai-reasoning',
  AI_ANALYSIS_STREAMING: 'hs2a-ai-streaming',
  AI_ANALYSIS_FREE_FORM: 'hs2a-ai-free-form',
  AI_PROMPT_CONFIG: 'hs2a-ai-prompt-config',
  HIDE_MOBILE_WARNING: 'hideMobileWarning',
  THEME_MODE: 'hs2a-theme-mode'
} as const

export const getSecureKeySuffix = (baseKey: string, suffix: string = 'key'): string => {
  return `${baseKey}-${suffix}`
}

export const API_ENDPOINTS = {
  posts: '/apis/api.content.halo.run/v1alpha1/posts',
  tags: '/apis/api.content.halo.run/v1alpha1/tags',
  categories: '/apis/api.content.halo.run/v1alpha1/categories'
} as const
